import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import image1 from '../../images/6D5A0194 A.jpg'
import image2 from '../../images/6D5A0240.jpg'

function AboutTwo() {
  return (
    <Box sx={{ flexGrow: 1, padding: "20px" }}>
      <Grid container spacing={2}>
        {/* Left Section - Images */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              position: "relative",
              marginTop:{lg: '100px'}
              
            }}
          >
            <Box
              component="img"
              src={image1} // Replace with the night image URL or local path
              alt="Night path"
              sx={{
                width: "80%",
                borderRadius: "8px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                backgroundColor: "rgb(0,0,0,1)"

              }}
            />
            <Box
              component="img"
              src={image2} // Replace with the pool image URL or local path
              alt="Pool and palm trees"
              sx={{
                position: "absolute",
                top: "50%",
                left: "70%",
                transform: "translate(-50%, -50%)",
                width: "60%",
                borderRadius: "8px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                zIndex: 2,
              }}
            />
          </Box>
        </Grid>

        {/* Right Section - Text Content */}
        <Grid item xs={12} md={6}>
          <Box sx={{ padding: "20px" }}>
            <Typography
              variant="overline"
              sx={{
                color: "#7b7b7b",
                textTransform: "uppercase",
                letterSpacing: "1px",
              }}
            >
              A Short Description Of Us
            </Typography>
            <Typography
              variant="h4"
              sx={{
                fontWeight: "bold",
                marginTop: "10px",
                marginBottom: "20px",
                fontFamily: "Georgia, serif",
              }}
            >
             Unseen Knuckles Eco Boutique 
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "#555",
                marginBottom: "20px",
                lineHeight: 1.8,
              }}
            >
              Since 2024, Unseen Knuckles Eco Boutique has been dedicated to creating exceptional resort experiences that celebrate the beauty of nature. Drawing on decades of collective expertise in the hospitality industry, we have crafted a boutique retreat that invites you to immerse yourself in the breathtaking landscapes of a UNESCO World Heritage site. Enveloped in misty mountains and lush greenery, and warmed by the smiles of the local community, Unseen Knuckles offers a sanctuary for the soul.
              Our resort is designed to provide a personalized escape for those seeking tranquility, adventure, and refined comfort. 

            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "#555",
                lineHeight: 1.8,
              }}
            >
With two thoughtfully curated chalets, we combine modern elegance with authentic local craftsmanship, creating spaces that reflect the unique charm of the region. At Unseen Knuckles, we believe unforgettable stays are built on thoughtful attention to detail, ensuring every guest experiences the extraordinary.
Escape the ordinary and embrace the exceptional at Unseen Knuckles—a place where lasting memories are made.
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default AboutTwo;
